<template>
    <div>
        <footer class="custom-footer">
            <div class="flex-column d-flex align-items-center py-3">
                <div class="pt-1">
                    <span @click="$router.push('/cookie-policy')" style="cursor: pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="#fff">
                            <path
                                d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-75 29-147t81-128.5q52-56.5 125-91T475-881q21 0 43 2t45 7q-9 45 6 85t45 66.5q30 26.5 71.5 36.5t85.5-5q-26 59 7.5 113t99.5 56q1 11 1.5 20.5t.5 20.5q0 82-31.5 154.5t-85.5 127q-54 54.5-127 86T480-80Zm-60-480q25 0 42.5-17.5T480-620q0-25-17.5-42.5T420-680q-25 0-42.5 17.5T360-620q0 25 17.5 42.5T420-560Zm-80 200q25 0 42.5-17.5T400-420q0-25-17.5-42.5T340-480q-25 0-42.5 17.5T280-420q0 25 17.5 42.5T340-360Zm260 40q17 0 28.5-11.5T640-360q0-17-11.5-28.5T600-400q-17 0-28.5 11.5T560-360q0 17 11.5 28.5T600-320ZM480-160q122 0 216.5-84T800-458q-50-22-78.5-60T683-603q-77-11-132-66t-68-132q-80-2-140.5 29t-101 79.5Q201-644 180.5-587T160-480q0 133 93.5 226.5T480-160Zm0-324Z" />
                        </svg>
                        Cookie policy
                    </span>
                </div>
                <div class="container">
                    <el-divider></el-divider>
                </div>
                <div class="d-flex flex-md-row flex-column align-items-center px-3">
                    <img src="../assets/tocc-mic.jpg" style="height: 180px" alt="pnrr-tocc">
                    <div class="text-start px-3">
                        <p class="fw-bold">Finanziato dall’Unione Europea – Next Generation EU – PNRR Transizione
                            Ecologica
                            Organismi
                            Culturali e Creativi</p>
                        INCENTIVO Decreto Direttoriale n. 385 del 19/10/2022
                        <br>
                        PROT. PROGETTO TOCC0001822
                        <br>
                        COR 15911904 / CUP C97J23000660008
                    </div>
                </div>

            </div>
        </footer>
        <div class="p-2" style="background-color: darkslategray; color: white">
            Premio Forlano, {{ new Date().getFullYear() }} - tutti i diritti riservati
        </div>
    </div>
</template>


<style scoped>
.custom-footer {
    background-color: #001719;
    color: #fbfbfb;
}
</style>